import store from '@/store';

export default (to, from, next) => ({
    allow: store.getters.is_hide_prepay_topup,
    redirect: { name: 'not-found' },
});
